import React from 'react';
import Text from '@common-components/form/Text';
import { Link } from 'react-router-dom';
import { ConditionalRendering } from '@common-components/conditional-rendering';

interface ICardProps {
    classes: {
        card: string[];
        media: string[];
        content?: string[];
    };
    mediaExists: boolean;
    contentHeader: {
        headerId: string;
        headerClasses: string[];
        headerText: string;
        headerDisplay: string;
        headerTextReplacements?: object;
    };
    contentText: {
        textId: string;
        textClasses: string[];
        text: string;
        display: string;
        textReplacements?: object;
        isReplacementALink?: boolean;
        contentRedirects?: string;
        linkText?: string;
    };
    actions: {
        cardRedirect: string;
        isExternal: boolean;
    };
    id: {
        idValue: string;
    };
    gtm?: {
        gtmValue: string | null;
    };
}

export default function Card({
    classes: { card, media, content },
    mediaExists,
    contentHeader: { headerId, headerClasses, headerText, headerDisplay, headerTextReplacements },
    contentText: {
        textId,
        textClasses,
        text,
        display,
        textReplacements,
        isReplacementALink,
        contentRedirects,
        linkText,
    },
    actions: { cardRedirect, isExternal },
    id: { idValue },
    gtm = { gtmValue: null },
}: ICardProps) {
    return (
        <div className={card?.join(' ')}>
            <ConditionalRendering isTrue={isExternal}>
                <a id={idValue} href={cardRedirect} className="gi-card" data-gtm-value={gtm.gtmValue}>
                    <ConditionalRendering isTrue={mediaExists}>
                        <div className={`gi-card__media ${media?.join(' ')}`}> </div>
                    </ConditionalRendering>
                    <div className={`gi-card__content__wrapper ${content?.join(' ')}`}>
                        <div className="gi-card__content">
                            <div className="gi-card__content__heading">
                                <Text
                                    {...{
                                        id: headerId,
                                        classes: headerClasses,
                                        text: headerText,
                                        display: headerDisplay,
                                        textReplacements: headerTextReplacements,
                                    }}
                                />
                            </div>
                            <div className="gi-card__content__body">
                                <Text
                                    {...{
                                        id: textId,
                                        classes: textClasses,
                                        text,
                                        display,
                                        textReplacements,
                                        isReplacementALink,
                                        path: contentRedirects,
                                        linkText,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </a>
            </ConditionalRendering>
            <ConditionalRendering isTrue={!isExternal}>
                <Link id={idValue} to={cardRedirect} className="gi-card">
                    <ConditionalRendering isTrue={mediaExists}>
                        <div className={`gi-card__media ${media?.join(' ')}`}> </div>
                    </ConditionalRendering>
                    <div className="gi-card__content__wrapper">
                        <div className="gi-card__content">
                            <div className="gi-card__content__heading">
                                <Text
                                    {...{
                                        id: headerId,
                                        classes: headerClasses,
                                        text: headerText,
                                        display: headerDisplay,
                                        textReplacements: headerTextReplacements,
                                    }}
                                />
                            </div>
                            <div className="gi-card__content__body">
                                <Text
                                    {...{
                                        id: textId,
                                        classes: textClasses,
                                        text,
                                        display,
                                        textReplacements,
                                        isReplacementALink,
                                        path: contentRedirects,
                                        linkText,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </Link>
            </ConditionalRendering>
        </div>
    );
}
